import gql from 'graphql-tag';

export default gql`
    mutation AddDriverLoadNotes($input: AddDriverLoadNotesInput) {
        addDriverLoadNotes(input: $input) {
            errors
            createdDriverLoadNotesId
        }
    }
`;
